import {
  type ControlCardInstanceOverrideValidationResultInput,
  OverrideControlCardValidationResultDocument,
  type ValueInstanceFragment
} from "app/gql/graphqlSchema";
import {query} from "app/gql/client";
import {useCallback} from "react";
import {useLoadingContext} from "app/employee/LoadingContext";
import {useControlCardInstanceContext} from "app/employee/controlCard/ControlCardInstanceContext";

const overrideControlCardValidationResultApi = async (input: ControlCardInstanceOverrideValidationResultInput) => {
  const result = await query(OverrideControlCardValidationResultDocument, {input});
  return result.controlCardInstanceOverrideValidationResult;
};

export const useOverrideControlCardValidationResult = (valueInstance: Pick<ValueInstanceFragment, "id">) => {
  const {instance, updateValues} = useControlCardInstanceContext();

  const {startLoading, finishLoading, showExceptionError} = useLoadingContext();

  const overrideValidationResult = useCallback(
    async (reason: string) => {
      try {
        startLoading();
        const result = await overrideControlCardValidationResultApi({
          instanceId: instance.id,
          valueIds: [valueInstance.id],
          reason
        });
        const updatedValues = result.values;
        updateValues(updatedValues);
      } catch (e) {
        await showExceptionError(e);
      } finally {
        finishLoading();
      }
    },
    [finishLoading, instance.id, showExceptionError, startLoading, updateValues, valueInstance]
  );

  return {overrideValidationResult};
};
